import React from "react";
import { Link, useParams } from "react-router-dom";
// import banner from "./images/Blog-banner.png";
import BlogsForm from "./blogsform";

import { type } from "@testing-library/user-event/dist/type";
import { assets } from "../assets/assets";

const latestnewsdetails = [
  {
    id: 15,
    title: "Meet Our New Climate Storyteller",
    subtitle: "by admin | July 01, 2025 | Latest News | 3 comments",
    image: assets.Pratibha, // Use your thumbnail asset
    bannerImage: assets.Pratibha, // Use your banner asset
    description: [
      {
        type: "p",
        content:
          "Introducing: Pratibha Chauhan Equestrian | Journalism & Mass Comm.| Next-Gen Climate Voice",
      },
      {
        type: "p",
        content:
          "Wendy is not just a business leader—she is a transformational catalyst. Her career has spanned industries and continents, delivering exceptional results by merging deep technology fluency with visionary growth strategies. She brings with her a unique blend of strategic consulting, client relationship management, and creative entrepreneurship.",
      },
      {
        type: "p",
        content:
          "Pratibha joins us to lead a bold, human-first storytelling movement from the ground up—literally. She will be Accel1's first-ever Climate Storyteller, capturing frontline impact through reels, podcasts, field dispatches, and raw, immersive digital narratives. Think Insta Lives from desert climate labs, interviews with water warriors, and mini-docs on climate tech revolutions—all through the lens of youth and justice.",
      },
      {
        type: "h2",
        content: "What's Coming",
      },
      {
        type: "h3",
        content: "On-the-ground Reporting",
      },
      {
        type: "p",
        content:
          "Straight from solar fields, salt mines, and hydro farms. She'll capture the voices of farmers, engineers, and eco-warriors reshaping our planet.",
      },
      {
        type: "h3",
        content: "Podcasts with Climate Mavericks",
      },
      {
        type: "p",
        content:
          "Global thought leaders and grassroots heroes. Expect cross-continental conversations that break silos and spark change.",
      },
      {
        type: "h3",
        content: "Viral-Ready Reels & Shorts",
      },
      {
        type: "p",
        content:
          "Climate storytelling—Gen Z style. On Instagram, YouTube Shorts, and TikTok, where the next generation actually listens.",
      },

      {
        type: "h3",
        content: "Brand New Energy",
      },
      {
        type: "p",
        content:
          " From poetic climate diaries to interactive map journeys—Pratibha brings a bold, experimental spirit to Sustainability and Social Empowerment storytelling.",
      },
      {
        type: "h3",
        content: "Why It's Cool AF",
      },
      {
        type: "p",
        content: "Let's be honest—climate comms needs a remix. And this is it.",
      },
      {
        type: "p",
        content:
          "We're turning ESG into something emotional, cinematic, and culture-shifting. Through Pratibha's lens, we won't just track carbon. We'll track hope, resilience, and human grit. And we'll share it with the world—raw, real, and beautifully unfiltered.",
      },

      {
        type: "h3",
        content: "Follow the Journey",
      },
      {
        type: "ul",
        content: [
          "IG: @thefifthclimate",
          "YouTube: @thefifthclimate",
          "X: thefifthclimate",
          "FB: thefifthclimate",
        ],
      },
      {
        type: "p",
        content:
          "First story drops soon. The Future of Climate is Story-Led. Welcome to the revolution, Pratibha.",
      },
      {
        type: "p",
        content:
          "About Accel1 is a next-generation climate intelligence company on a mission to empower nations, businesses, and communities to thrive in a climate-impacted world. At the intersection of AI, sustainability science, and planet-scale engineering, Accel1 is redefining how climate action is measured, managed, and monetized. Our platforms are not just digital tools — they are engines of transformation, regenerative agriculture, water intelligence, decarbonization, and disaster resilience. We go beyond reporting — we solve.",
      },
      {
        type: "h3",
        content: "Why Accel1?",
      },
      {
        type: "ul",
        content: [
          "Government-Ready: Supporting climate compliance, net-zero mandates, and climate-proofing of critical sectors across geographies.",
          "Revenue-Realizing: Helps enterprises unlock new revenue streams via verified carbon credits, climate-linked finance, and sustainability-linked incentives.",
          "AI-First: Purpose-built large language models and predictive analytics designed for carbon, water, and resilience use cases.",
        ],
      },
      {
        type: "h2",
        content: "Our Impact:",
      },
      {
        type: "ul",
        content: [
          "Empowering millions of farmers with climate-smart tools.",
          "Enabling enterprise decarbonization and sustainability optimization across industries.",
          "Supporting government missions from water conservation to tribal regeneration and net-zero transitions.",
          "Driving climate equity, ensuring that vulnerable communities are equipped with tools for survival, dignity, and growth.",
        ],
      },
    ],
  },

  {
    id: 14,
    title:
      "Wendy Atlin Joins Accel1 as Chief Growth Officer to Spearhead Global Climate-Tech Growth",
    subtitle: "by admin | Jun 10, 2025 | Latest News | 0 comments",
    image: assets.wendyBanner, // Use your thumbnail asset
    bannerImage: assets.wendyBanner, // Use your banner asset
    description: [
      {
        type: "p",
        content:
          "We are thrilled to announce that Wendy Atlin has joined Accel1 as our Chief Growth Officer (CGO), stepping into a defining leadership role at a pivotal moment in our scale-up journey. As CGO, Wendy will lead our strategic growth charter across North America, MENA, and other key global markets—mobilizing partnerships, revenue, and brand resonance in the climate-tech and sustainability ecosystem.",
      },
      {
        type: "p",
        content:
          "Wendy is not just a business leader—she is a transformational catalyst. Her career has spanned industries and continents, delivering exceptional results by merging deep technology fluency with visionary growth strategies. She brings with her a unique blend of strategic consulting, client relationship management, and creative entrepreneurship.",
      },
      {
        type: "quote",
        content:
          "“I’m deeply passionate about creating new realities through innovation and agile mechanisms,” said Wendy. “Accel1 is uniquely positioned to deliver meaningful, profitable impact while addressing the world’s most urgent challenge — climate resilience. I’m honored to join this mission and lead the growth vision forward.”",
      },
      {
        type: "h2",
        content: "A Message from Sanjay Kommera, CEO of Accel1",
      },
      {
        type: "quote",
        content:
          "“Wendy joins us at a defining moment — as we scale Accel1 into a global climate-tech leader. Her strategic instincts, deep expertise across growth, technology, and transformation, and her powerful energy will be instrumental in shaping our future. She embodies the bold, mission-driven spirit of Accel1 — and we couldn’t be more excited to have her onboard.”",
      },
      {
        type: "h2",
        content: "About Accel1",
      },
      {
        type: "p",
        content:
          "Accel1 is a next-generation climate intelligence company on a mission to empower nations, businesses, and communities to thrive in a climate-impacted world. At the intersection of AI, sustainability science, and planet-scale engineering, Accel1 is redefining how climate action is measured, managed, and monetized.",
      },
      {
        type: "p",
        content:
          "Our platforms are not just digital tools — they are engines of transformation, regenerative agriculture, water intelligence, decarbonization, and disaster resilience. We go beyond reporting — we solve.",
      },
      {
        type: "h2",
        content: "Why Accel1?",
      },
      {
        type: "ul",
        content: [
          "Government-Ready: Supporting climate compliance, net-zero mandates, and climate-proofing of critical sectors across geographies.",
          "Revenue-Realizing: Helps enterprises unlock new revenue streams via verified carbon credits, climate-linked finance, and sustainability-linked incentives.",
          "AI-First: Purpose-built large language models and predictive analytics designed for carbon, water, and resilience use cases.",
        ],
      },
      {
        type: "h2",
        content: "Our Impact:",
      },
      {
        type: "ul",
        content: [
          "Empowering millions of farmers with climate-smart tools.",
          "Enabling enterprise decarbonization and sustainability optimization across industries.",
          "Supporting government missions from water conservation to tribal regeneration and net-zero transitions.",
          "Driving climate equity, ensuring that vulnerable communities are equipped with tools for survival, dignity, and growth.",
        ],
      },
      {
        type: "p",
        content:
          "With Wendy’s leadership, we are entering a new chapter — bold in ambition, sharp in execution, and unwavering in our commitment to planetary stewardship.",
      },
      {
        type: "p",
        content: "Join us as we accelerate toward impact.",
      },
    ],
  },

  {
    id: 13,
    title: "Stay updated with the pulse of climate-tech innovation",
    subtitle: "by admin | June 01, 2025 | Latest News",
    image: assets.Stayupdated2,
    bannerImage: assets.Stayupdated2,
    description: [
      {
        type: "p",
        content:
          "Catch the latest breakthroughs, partnerships, deployments, and leadership moves as Accel1 accelerates sustainable impact across regions — from Rajasthan’s farms to global boardrooms.",
      },
    ],
  },
  {
    id: 1,
    title:
      "Accel1 Announces Strategic Acquisition of RR Engineers to Strengthen Sustainable Water Solutions Portfolio",
    subtitle: "by admin | Apr 22, 2025 | Latest News | 0 comments",
    image: assets.app22_2025,
    bannerImage: assets.rrlatestnews,
    description: [
      {
        type: "p",
        content:
          "Accel1, a global climate-tech and sustainability solutions leader, is pleased to announce the acquisition of RR Engineers, a pioneering Indian company with over 22 years of experience in sustainable water management. This acquisition marks a significant milestone in Accel1’s mission to build a holistic, tech-enabled platform for climate resilience, water security, and community impact.",
      },
      {
        type: "p",
        content:
          "Founded in India, RR Engineers (www.rrengineers1.com) has built a strong reputation across industries, institutions, and local bodies through its innovative and eco-efficient water solutions. Its core services include efficient irrigation systems, groundwater recharging, hydro testing & water quality assessment, water distribution systems, wastewater recycling solutions, and rainwater harvesting and conservation infrastructure.",
      },
      {
        type: "ul",
        content: [
          "Efficient Irrigation Systems",
          "Groundwater Recharging",
          "Hydro Testing & Water Quality Assessment",
          "Water Distribution Systems",
          "Wastewater Recycling Solutions",
          "Rainwater Harvesting and Conservation Infrastructure",
        ],
      },
      {
        type: "image",
        src: "../images/ceo-quote-image.png", // Adjust the path as needed
        title: "Sanjay Kommera, CEO and santhosh kumar",
      },
      {
        type: "p",
        content:
          "Through this acquisition, Accel1 will integrate RR Engineers’ domain expertise, on-ground infrastructure, and implementation capabilities with its AI-driven platforms like HydroTRACE™—creating a unified value proposition for governments, enterprises, and rural communities.",
      },
      {
        type: "image",
        src: "../images/ceo-quote-image.png", // Adjust the path as needed
        title: "Sanjay Kommera, CEO",
      },
      {
        type: "p",
        content:
          "Sanjay Kommera, CEO of Accel1, stated: 'RR Engineers has demonstrated two decades of deep commitment to solving India’s water challenges through scalable, locally grounded solutions. This acquisition enables us to deliver impact faster and farther—combining advanced water intelligence with proven field expertise to build a water-secure future.'",
      },
      {
        type: "image",
        src: "../images/ceo-quote-image.png", // Adjust the path as needed
        title: "Santosh Kumar Chillappa",
      },
      {
        type: "p",
        content:
          "Santosh Kumar Chillappa, Founder and Managing Director of RR Engineers, added: 'Water is the foundation of all life—and for over two decades, we’ve worked tirelessly to conserve every drop. Joining Accel1 is not just a business move; it’s a shared mission. Together, we will scale water sustainability across India and beyond, combining our implementation strength with digital intelligence to create long-term, measurable impact.'",
      },
      {
        type: "p",
        content:
          "The acquisition also expands Accel1’s reach into critical water-stressed regions, enhances its ability to deliver end-to-end water lifecycle solutions, and reinforces its commitment to SDG 6 – Clean Water and Sanitation for All.",
      },
      {
        type: "h2",
        content: "About Accel1",
      },
      {
        type: "p",
        content:
          "Accel1 is a global climate-tech innovation company delivering cutting-edge solutions across water intelligence (HydroTRACE™), carbon & circular economy (BioFORGE™), and enterprise ESG data (AccelTRACK™). With operations across India, the Middle East, and North America, Accel1 partners with governments, industries, and communities to build sustainable infrastructure for a resilient future.",
      },
      {
        type: "p",
        content: "Learn more: www.accel1.com",
      },
    ],
  },
  {
    id: 2,
    title:
      "Accel1 Launches Climate Engineering Vertical to Pioneer Sustainable Water and Climate Solutions",
    subtitle: "by admin | Apr 7, 2025 | Latest News | 0 comments",
    image: assets.app7_2025,
    bannerImage: assets.Climatelatestnews,
    description: [
      {
        type: "p",
        content:
          "As part of our unwavering commitment to sustainability and climate resilience, Accel1 is proud to announce the launch of our Climate Engineering Vertical. This strategic initiative is designed to drive innovation in climate solutions and environmental stewardship, with a primary focus on our most advanced HydroTRACE™ Platform, BioFORGE™ System, and Sustainable Water Management Services.",
      },
      {
        type: "p",
        content:
          "To lead this initiative, we are honored to welcome two distinguished executives: Dr. Sai Bhaskar Reddy Nakka as Chief Climate Engineering Officer and Shashank Taman as Chief Climate Solutions Officer.",
      },
      {
        type: "h3",
        content:
          "Introducing HydroTRACE™, BioFORGE™, and Sustainable Water Management Services",
      },
      {
        type: "p",
        content:
          "Our Climate Engineering Vertical is anchored by HydroTRACE™, the most advanced water intelligence platform, integrating cloud tracing, rainwater analytics, groundwater analytics, surface water analytics, and cloud seeding technologies. HydroTRACE™ represents the next-generation approach to water conservation and sustainable water management, addressing critical challenges in global water security.",
      },
      {
        type: "p",
        content:
          "Complementing this, BioFORGE™ focuses on biochar and soil-carbon innovations to enhance climate-smart agriculture and carbon sequestration, while promoting circular economy principles. This platform helps regenerate degraded lands, boost soil fertility, and lock away atmospheric carbon sustainably.",
      },
      {
        type: "p",
        content:
          "Alongside HydroTRACE™ and BioFORGE™, our Sustainable Water Management Services encompass comprehensive solutions for water conservation, wastewater treatment, hydrological risk assessments, and climate-resilient infrastructure. These services empower governments, corporations, and communities to optimize water use, mitigate risks, and enhance climate adaptation strategies.",
      },
      {
        type: "h3",
        content:
          "Dr. Sai Bhaskar Reddy Nakka – Chief Climate Engineering Officer",
      },
      {
        type: "p",
        content:
          "Dr. Sai Bhaskar Reddy Nakka brings over two decades of experience in environmental and climate sciences, making him an invaluable leader in our Climate Engineering Vertical. With expertise spanning environment, climate change, disaster management, energy, agriculture, and water, Dr. Nakka has been at the forefront of sustainable development and climate resilience.",
      },
      {
        type: "ul",
        content: [
          {
            bold: "Key Highlights of Dr. Nakka’s Expertise:",
            text: "Holds double Master’s degrees in Applied Geology (IIT Bombay) and Geography.",
          },
          {
            bold: "PhD research:",
            text: "Focused on Environmental Impact Assessment (EIA) of industrial pollution in India.",
          },
          {
            bold: "Senior Disaster Risk Management Specialist:",
            text: "Served for the World Bank.",
          },
          {
            bold: "Innovative Environmental Solutions:",
            text: "Designed over 100 solutions, including 'Good Stoves,' revolutionizing biomass energy.",
          },
          {
            bold: "Policy Advocacy and Strategic Planning:",
            text: "Led climate risk assessments and sustainable agriculture initiatives.",
          },
        ],
      },
      {
        type: "p",
        content:
          "Dr. Nakka’s commitment to open knowledge and his extensive contributions to climate resilience, disaster risk reduction, and sustainable agriculture will be instrumental in advancing Accel1’s Climate Engineering innovations.",
      },
      {
        type: "h3",
        content: "Shashank Taman – Chief Climate Solutions Officer",
      },
      {
        type: "p",
        content:
          "Shashank Taman joins Accel1 with over 22 years of experience in climate engineering, sustainable infrastructure, and technology-driven environmental solutions. His leadership in climate resilience strategy, carbon management, and operational efficiency makes him a key driver of our climate solutions strategy.",
      },
      {
        type: "ul",
        content: [
          {
            bold: "Key Highlights of Shashank Taman’s Expertise:",
            text: "Extensive background in climate infrastructure, carbon footprint analysis, and environmental compliance frameworks.",
          },
          {
            bold: "Sustainability-driven Digital Transformation:",
            text: "Led projects at Equinix focused on energy efficiency and carbon neutrality.",
          },
          {
            bold: "International MBA:",
            text: "Holds an MBA from IE Business School, Spain.",
          },
          {
            bold: "Hydrological Modeling & Sustainable Energy Integration:",
            text: "Expertise in water resource optimization and sustainable energy.",
          },
          {
            bold: "Green Building Initiatives:",
            text: "Successfully implemented climate risk assessments for large-scale infrastructure.",
          },
        ],
      },
      {
        type: "p",
        content:
          "With Shashank’s expertise in climate engineering, sustainable resource management, and technology-driven resilience solutions, Accel1 is poised to revolutionize climate technology, ensuring businesses and governments leverage the latest innovations in sustainability and environmental monitoring.",
      },
      {
        type: "h3",
        content: "Raj Khaware – Chief Strategy Officer, Accel1 Inc.",
      },
      {
        type: "p",
        content:
          "The launch of our Climate Engineering Vertical marks a pivotal moment in Accel1’s journey toward global climate leadership. With Dr. Reddy and Mr. Taman at the helm, we are strengthening our commitment to innovation, resilience, and measurable climate impact. This is more than a business strategy — it’s a bold step toward safeguarding our future.",
      },
      {
        type: "h2",
        content: "A Future Built on Climate Innovation",
      },
      {
        type: "p",
        content:
          "Accel1’s Climate Engineering Vertical is dedicated to advancing cutting-edge climate technologies, fostering sustainable development, and mitigating environmental risks through innovation. With the leadership of Dr. Sai Bhaskar Reddy Nakka and Shashank Taman, and the strength of HydroTRACE™, BioFORGE™, and our climate engineering capabilities, we are confident in our ability to drive meaningful change in the fight against climate change.",
      },
      {
        type: "p",
        content:
          "Stay tuned for more updates as we continue our journey toward a more resilient and sustainable future.",
      },
      {
        type: "p",
        content: "www.accel1.com",
      },
      {
        type: "p",
        content: "sales@accel1.com",
      },
    ],
  },
  {
    id: 3,
    title:
      "Accel1 Launches AccelALERT: A Game-Changer in Health, Safety & Compliance",
    subtitle: "by admin | Mar 10, 2025 | Latest News | 0 comments",
    image: assets.accelalert,
    bannerImage: assets.latestnewsbanner,
    description: [
      {
        type: "p",
        content:
          "Accel1, a global leader in sustainability and ESG solutions, proudly announces the launch of AccelALERT, a real-time safety and compliance platform designed to revolutionize risk management for industries, governments, and businesses worldwide.",
      },
      {
        type: "p",
        content:
          "AccelALERT delivers instant hazard detection, risk mitigation, and seamless regulatory compliance, empowering organizations to create zero-incident workplaces and future-proof operations.",
      },
      {
        type: "h3",
        content: "Key Features of AccelALERT:",
      },
      {
        type: "ul",
        content: [
          {
            bold: "Real-Time Alerts:",
            text: " Detect and mitigate safety risks instantly.",
          },
          {
            bold: "Risk Analytics:",
            text: " Advanced machine learning for predictive safety management.",
          },
          {
            bold: "Regulatory & ESG Compliance:",
            text: " Automated reporting to meet global safety and sustainability standards.",
          },
          {
            bold: "Seamless Integration:",
            text: " Connects with IoT devices, CCTV, ERP, and ESG tracking systems.",
          },
          {
            bold: "Scalable & Industry-Specific:",
            text: " Customizable for manufacturing, logistics, healthcare, energy, and smart cities.",
          },
        ],
      },
      {
        type: "p",
        content:
          "With AccelALERT, we are setting new benchmarks in proactive safety intelligence,” said Mark Becking, Chief Product Officer, at Accel1. “This platform empowers organizations to not just react but predict, prevent, and protect, driving the next era of workplace safety and regulatory excellence.",
      },
      {
        type: "h3",
        content: "Designed for Global Compliance & Sustainability",
      },
      {
        type: "p",
        content:
          "AccelALERT aligns with leading health, safety, and ESG frameworks, including ISO 45001, OSHA, CSRD, and SEC Climate Disclosure. It supports businesses in achieving compliance, mitigating risks, and fostering a culture of safety and environmental responsibility.",
      },
      {
        type: "h3",
        content: "Now Available for Enterprises & Government Sectors",
      },
      {
        type: "p",
        content:
          "AccelALERT is now available for deployment across industries, government agencies, and infrastructure projects. Organizations can request a live demo to explore how AI-driven safety intelligence can transform their operations.",
      },
      {
        type: "h3",
        content:
          "For Media Inquiries, Product Demos, or Partnership Opportunities",
      },
      {
        type: "p",
        content: "Contact: sales@accel1.com www.accel1.com/accelalert",
      },
    ],
  },
  {
    id: 4,
    title:
      "PANA Holdings Takes a Major Step in Strengthening Its Sustainability Commitment by Signing a Multi-Year Deal with Accel1",
    subtitle: "by admin | Jan 29, 2025 | Latest News | 0 comments",
    image: assets.PanaNewsImg,
    bannerImage: assets.panabanner,
    description: [
      {
        type: "p",
        content:
          "PANA Holdings, a diversified global leader, delivering innovation and excellence across a wide range of industries, including energy, mining, power, industrial real estate, digital solutions, and agriculture, has announced a bold initiative to strengthen its commitment to sustainability by signing a multi-year deal with Accel1 to implement their innovative ESG data management platform, AccelTRACK, across all subsidiaries.",
      },
      {
        type: "p",
        content:
          "This transformative step underscores the company’s ambition to be a business platform of choice in Africa, with strategic global linkages as far as their eyes can see and thoughts imagine.",
      },
      {
        type: "h3",
        content: "Guiding Values: The 3Cs and 3Ts",
      },
      {
        type: "ul",
        content: [
          {
            bold: "The 3C’s:",
            text: " Character, Capacity, and Commitment—fundamental traits that define the company’s actions and integrity.",
          },
          {
            bold: "The 3T’s:",
            text: " Time, Transparency, and Trust—key elements that drive trustworthiness and accountability in all endeavors.",
          },
        ],
      },
      {
        type: "p",
        content:
          "These values form the bedrock of PANA Holdings’ approach to sustainability and business excellence, ensuring that its decisions positively impact communities, customers, and the environment.",
      },
      {
        type: "quote",
        content:
          "Sustainability drives our mission to deliver value to stakeholders, communities, and the environment, as we strive to be Africa’s business platform of choice with global strategic linkages.",
      },
      {
        type: "h3",
        content: "Paving the Path to Sustainable Leadership",
      },
      {
        type: "p",
        content:
          "PANA Holdings has structured its sustainability roadmap to deliver measurable progress while addressing global challenges like climate change. The company remains steadfast in its commitment to long-term growth, customer confidence, and global impact.",
      },
      {
        type: "h3",
        content: "Leveraging AccelTRACK for Data-Driven Progress",
      },
      {
        type: "p",
        content:
          "To support its ambitious sustainability goals, PANA Holdings has selected AccelTRACK, a leading ESG data management platform from Accel1 Inc., following a comprehensive analysis of solutions available in the market.",
      },
      {
        type: "ul",
        content: [
          {
            bold: "Advanced Data Management:",
            text: " Streamlining ESG data collection, reporting, and analysis for actionable insights.",
          },
          {
            bold: "Transparency and Accountability:",
            text: " Delivering highly auditable and verifiable metrics for stakeholders and regulators.",
          },
          {
            bold: "Flexibility and Customization:",
            text: " Tailoring solutions to meet PANA Holdings’ unique sustainability requirements.",
          },
          {
            bold: "Scalability for Growth:",
            text: " Supporting future expansion while adapting to evolving ESG frameworks and global standards.",
          },
        ],
      },
      {
        type: "quote",
        content:
          "At PANA Holdings, sustainability is at the heart of our mission to drive progress and deliver value not just to our stakeholders, but to the communities and environments we operate in.",
      },
      {
        type: "h3",
        content: "Vision for the Future",
      },
      {
        type: "p",
        content:
          "PANA Holdings’ vision is clear: To be a business platform of choice in Africa, with strategic global linkages as far as their eyes can see and thoughts imagine. By embedding data-driven insights into its sustainability journey, the company is poised to inspire confidence among stakeholders, drive meaningful change, and set a benchmark for sustainable business practices across Africa and beyond.",
      },
      {
        type: "h3",
        content: "About PANA Holdings",
      },
      {
        type: "p",
        content:
          "PANA Holdings is a diversified global business platform of unmatched enterprise, with a strong presence across key industries, including energy, mining, power, industrial real estate, and agriculture. Renowned for its commitment to innovation and sustainability, PANA Holdings delivers cutting-edge solutions that drive growth, create value, and set new benchmarks across multiple sectors.",
      },
    ],
  },
  {
    id: 5,
    title:
      "AccelESG Recognized as a Major Contender in Everest Group’s ESG Data Management Platform PEAK Matrix® Assessment 2024",
    subtitle: "by admin | Nov 18, 2024 | Latest News | 0 comments",
    image: assets.latestnews,
    bannerImage: "",
    description: [
      {
        type: "p",
        content:
          "AccelESG, a leader in ESG (Environmental, Social, and Governance) data management and sustainability solutions, is proud to announce its recognition as a Major Contender in the 2024 ESG Data Management Platform PEAK Matrix® Assessment by Everest Group.",
      },
      {
        type: "p",
        content:
          "As a globally trusted research and advisory firm, Everest Group delivers strategic insights to The Global 1000 companies. The ESG Data Management Platform PEAK Matrix® evaluates top platforms based on market impact, strategic vision, and delivery capabilities, positioning AccelESG as a major force in the industry.",
      },
      {
        type: "p",
        content:
          "With increasing scrutiny from regulators and heightened public awareness of environmental issues, effective ESG data management has become essential for companies to meet compliance requirements and enhance their operational efficiencies.",
      },
      {
        type: "h3",
        content: "Innovating at the Intersection of ESG and Technology",
      },
      {
        type: "quote",
        content:
          "We are honored to be recognized as a Major Contender by Everest Group. This achievement reflects our ongoing commitment to helping organizations reach their ESG goals by providing robust, data-centered solutions that drive meaningful change.",
      },
      {
        type: "p",
        content:
          "AccelESG’s platform offers an extensive suite of capabilities that enable clients to achieve responsible growth through data-driven decision-making across various facets of sustainability and governance:",
      },
      {
        type: "ul",
        content: [
          {
            bold: "Audit Ready ESG Reporting:",
            text: " Deliver a comprehensive suite of tools for ESG data management, reporting, and compliance. Features include advanced analytics, regulatory compliance tracking, and dynamic reporting capabilities.",
          },
          {
            bold: "Supply Chain Sustainability:",
            text: " Track and assess supplier compliance and carbon footprint, enabling businesses to align with circular economy goals and implement sustainable sourcing.",
          },
          {
            bold: "Health and Safety Management:",
            text: " Integrates advanced features to help clients identify risks, manage incidents, and maintain regulatory compliance.",
          },
          {
            bold: "Financed Emissions Tracking:",
            text: " Track and manage financed emissions, allowing financial institutions and corporates to understand their environmental impact through investments and loans.",
          },
        ],
      },
      {
        type: "h3",
        content: "Client-First, Future-Forward Approach",
      },
      {
        type: "quote",
        content:
          "Our recognition as a Major Contender speaks to our dedication to empowering clients through transformative ESG solutions.",
      },
      {
        type: "h3",
        content: "About AccelESG",
      },
      {
        type: "p",
        content:
          "Headquartered in Atlanta, AccelESG is a pioneering provider of ESG and sustainability solutions, serving global enterprises with a full suite of ESG reporting, supply chain management, health and safety compliance, and data integrity tools.",
      },
    ],
  },
  {
    id: 6,
    title:
      "Zain Group selects AccelTRACK for reporting, transparency, and accountability on environmental, social, and governance (ESG) metrics.",
    subtitle: "by admin | Oct 1, 2024 | Latest News | 0 comments",
    image: assets.oct1_2024,
    bannerImage: assets.bannerimgoct7,
    description: [
      {
        type: "p",
        content:
          "Zain Group, a leading provider of innovative technologies and digital lifestyle communications operating in eight markets across the Middle East and Africa, has selected Bahwan CyberTek (BCT) and AccelESG for the deployment of the AccelTRACK solution, a cutting-edge ESG Data Management Platform that will support and enhance Zain’s reporting, transparency, and accountability on environmental, social, and governance (ESG) metrics.",
      },
      {
        type: "p",
        content:
          "This implementation will reflect a monumental achievement in Zain Group’s broader sustainability journey, reaffirming the company’s commitment to environmental, social, and governance (ESG) excellence while advancing industry leadership in sustainable business practices.",
      },
      {
        type: "quote",
        content:
          "Zain’s corporate sustainability mission is to provide meaningful connectivity leading to equitable systemic change, empowering the communities we serve and beyond.",
      },
      {
        type: "h3",
        content: "The Strategic Role of AccelTRACK",
      },
      {
        type: "p",
        content:
          "AccelTRACK, developed by AccelESG, is an advanced ESG Data Management Platform that allows organizations to seamlessly manage their ESG data while ensuring adherence to complex regulatory requirements.",
      },
      {
        type: "ul",
        content: [
          {
            bold: "Automated ESG Data Collection and Integration:",
            text: " AccelTRACK centralizes data from various departments and geographies, automating collection processes, reducing manual errors, and creating a single source of truth for ESG data.",
          },
          {
            bold: "Comprehensive Reporting:",
            text: " Zain will have access to real-time analytics and customized reports that track progress on critical ESG KPIs.",
          },
          {
            bold: "Customizable Dashboards:",
            text: " Leadership at Zain will have the ability to track performance against their strategic sustainability goals with bespoke dashboards.",
          },
          {
            bold: "Global Regulatory Compliance:",
            text: " AccelTRACK ensures Zain Group complies with global regulations, including forthcoming capital markets requirements and other key sustainability frameworks.",
          },
        ],
      },
      {
        type: "h3",
        content: "Zain’s ESG Journey and Commitment to Sustainability",
      },
      {
        type: "p",
        content:
          "For Zain, the implementation of AccelTRACK is not just a technology upgrade—it’s a crucial part of the company’s sustainability strategy.",
      },
      {
        type: "p",
        content:
          "The addition of Zain as a client highlights the growing demand for advanced ESG platforms like AccelTRACK and the strategic role that BCT and AccelESG play in shaping the future of responsible, sustainable business operations across industries.",
      },
      {
        type: "h3",
        content: "Conclusion",
      },
      {
        type: "p",
        content:
          "This deployment not only reinforces BCT’s and AccelESG’s credibility in delivering state-of-the-art ESG solutions but also strengthens Zain’s position as a sustainability leader in the telecommunications space.",
      },
    ],
  },
  {
    id: 7,
    title:
      "AccelESG Welcomes Balvinder Mangat as Vice President of Delivery Excellence",
    subtitle: "by admin | Aug 19, 2024 | Latest News | 0 comments",
    image: assets.aug19_2024,
    bannerImage: assets.Balvindermangat,
    description: [
      {
        type: "p",
        content:
          "AccelESG is proud to announce the appointment of Balvinder Mangat as our new Vice President of Delivery Excellence. Balvinder joins us with an impressive 23-year career in corporate leadership, having held pivotal roles at global powerhouses such as Cognizant and Uber. Her arrival at AccelESG marks a significant milestone in our journey to deliver unparalleled value and excellence to our clients.",
      },
      {
        type: "h3",
        content: "A Proven Leader in Delivery Excellence",
      },
      {
        type: "p",
        content:
          "Balvinder’s career is a testament to her expertise in driving operational excellence and delivering innovative solutions across a variety of sectors. Her experience spans a diverse range of industries, with a particular focus on the Insurance and Healthcare sectors. Throughout her career, she has consistently demonstrated her ability to lead large-scale transformation initiatives, streamline operations, and optimize delivery processes to achieve remarkable results.",
      },
      {
        type: "p",
        content:
          "At Cognizant, Balvinder played a key role in scaling their global delivery capabilities, overseeing complex projects and ensuring that the highest standards of quality and efficiency were maintained. Her tenure at Uber saw her contribute to the company’s rapid growth, where she led critical initiatives that enhanced service delivery and operational performance.",
      },
      {
        type: "h3",
        content: "Impact on AccelESG’s Mission",
      },
      {
        type: "p",
        content:
          "As Vice President of Delivery Excellence at AccelESG, Balvinder will be responsible for shaping and executing our delivery strategy, ensuring that we continue to exceed client expectations by delivering transformative solutions that drive measurable business outcomes. Her deep knowledge of the Insurance and Healthcare sectors will be instrumental in expanding our footprint in these industries, while her leadership will further strengthen our commitment to operational excellence across all projects. Balvinder’s strategic vision and hands-on approach will enable AccelESG to optimize our delivery processes, enhance client satisfaction, and achieve our growth objectives. Her leadership will be central to advancing our mission of providing cutting-edge ESG solutions that empower organizations to navigate the complexities of sustainability, compliance, and governance.",
      },
      // {
      //   type: "p",
      //   content:
      //     "Balvinder’s leadership will further strengthen our commitment to operational excellence across all projects and will be instrumental in expanding our footprint in the Insurance and Healthcare sectors.",
      // },
      {
        type: "h3",
        content: "A Commitment to Innovation and Client Success",
      },
      {
        type: "p",
        content:
          "Balvinder’s addition to our leadership team underscores AccelESG’s unwavering commitment to innovation, quality, and client success. With her at the helm of our delivery operations, we are confident that AccelESG will continue to set new standards in the industry.",
      },
      {
        type: "h3",
        content: "Join Us in Welcoming Balvinder Mangat",
      },
      {
        type: "p",
        content:
          "We are excited to embark on this new chapter with Balvinder Mangat as part of the AccelESG family. Her leadership will undoubtedly enhance our ability to deliver value to our clients, drive our strategic initiatives forward, and maintain our position as a leader in the ESG space.",
      },
      {
        type: "p",
        content:
          "Please join us in welcoming Balvinder to AccelESG and celebrating this exciting addition to our team!.",
      },
    ],
  },
  {
    id: 8,
    title: "Most Promising Technology Company Founded",
    subtitle: "by admin | Jun 16, 2024 | Latest News | 0 comments",
    image: assets.Top100,
    bannerImage: assets.PromisingTech,
    description: [
      {
        type: "p",
        content:
          "Environmental, social and governance (ESG) metrics are the compass for modern organizations, helping them attain sustainable success. These guide businesses toward greener growth and resilience in a world increasingly shaped by ethical standards and stakeholder expectations.",
      },
      {
        type: "p",
        content:
          "In today’s business world, where sustainability is more than a compliance checkbox, AccelESG stands as a reliable ESG partner for shaping corporate strategy. It has earned a reputation for integrating ESG principles into modern business operations through its innovative approach and comprehensive offerings.",
      },
      {
        type: "quote",
        content:
          "“We aim to redefine traditional business paradigms by guiding companies toward ethical leadership and enduring success in today’s dynamic global economy,” says Sanjay Kommera, CEO.",
      },
      {
        type: "image",
        src: "../images/ceo-quote-image.png", // Adjust the path as needed
        title: "Sanjay Kommera, CEO",
      },
      {
        type: "p",
        content:
          "The AccelESG team is well-versed in navigating the regulatory landscapes, managing vast amounts of ESG data, meeting heightened stakeholder expectations for transparency and seamlessly integrating sustainability into core business strategies. The team integrates data analytics, strategic advisory services and technology-driven solutions to address these recurring and multifaceted issues while meeting specific client needs.",
      },
      {
        type: "p",
        content:
          "The company empowers businesses to achieve sustainable growth and operational excellence by harnessing the transformative power of technology. AccelESG’s ESG reporting platform provides comprehensive, real-time data analytics, allowing businesses to accurately track and report their ESG performance. Its detailed reports cover metrics from carbon emissions and energy consumption to social impact and governance structures. This ensures compliance with regulatory requirements and enhances transparency, building trust with stakeholders and investors.",
      },
      {
        type: "p",
        content:
          "Beyond traditional ESG reporting, AccelESG seamlessly integrates sustainability into supply chain management. This helps clients to assess the environmental and social impacts of their entire supply chain, identifying areas for improvement and ensuring that suppliers also adhere to sustainable practices. They can create a more sustainable and ethical supply chain, reducing risks and enhancing overall ESG performance. The ESG platform also identifies opportunities for resource optimization and reduces costs and environmental impact. Proactive management mitigates sustainability risks, effectively enhancing business resilience and addressing long-term challenges.",
      },
      {
        type: "p",
        content:
          "AccelESG empowers businesses to manage risks while leveraging sustainability as a strategic advantage in today’s dynamic and challenging market. Its approach to sustainability risk management integrates ESG factors with traditional business metrics, offering a holistic and effective solution for modern enterprises. Clients can use this integrated framework to identify, evaluate and mitigate risks and enhance resilience, ensuring compliance and achieving sustainable growth.",
      },
      {
        type: "p",
        content:
          "The company realizes the complexity of gathering and managing vast amounts of ESG data from various sources, often leading to data inaccuracy, inconsistency and inaccessibility. AccelESG’s advanced data analytics platform consolidates ESG data from multiple sources, ensuring accuracy and consistency. The platform offers user-friendly dashboards and real-time analytics, making data accessible and actionable. This AI and ML-powered data analytics platform provides clients with predictive insights to anticipate future sustainability challenges and opportunities. As a result, they can optimize their sustainability initiatives through proactive strategies, ensuring maximum impact.",
      },
      {
        type: "p",
        content:
          "The platform also integrates seamlessly into enterprise resource planning systems, fostering sustainability across the value chain. AccelESG’s approach focuses on stakeholder engagement and offering robust communication platforms and collaboration features.",
      },
      {
        type: "p",
        content:
          "A typical client engagement at AccelESG begins with a detailed assessment of a client’s existing sustainability practices and benchmarking them against industry standards.",
      },
      {
        type: "p",
        content:
          "This initial evaluation is the foundation for designing customized strategies that align with specific sustainability goals and industry requirements. The team integrates these tailor-made strategies into the client’s business operations. The next step involves deploying advanced technologies for efficient data collection and analysis, ensuring real-time insights into ESG performance.",
      },
      {
        type: "p",
        content:
          "The driver of AccelESG’s success is its team of seasoned professionals with backgrounds in environmental science, finance and corporate governance. The dedication to continuous learning and creative problem-solving fuels the innovation at AccelESG. Collaboration and open communication are cornerstones of their teamwork, underpinned by a shared dedication to sustainability and mission-driven work. Diversity and inclusion enrich their perspectives, ensuring a supportive environment that prioritizes well-being. Their expertise, passion for impactful outcomes, client-centric focus and assurance of excellence all converge to advance AccelESG’s mission of creating a more sustainable world.",
      },
      {
        type: "p",
        content:
          "Going forward, the company envisions embedding sustainability in all aspects of life and business, including technology and innovation, expanding global influence, fostering collaborations, empowering through education and building resilience against environmental threats. It is positioned to have a sustainable effect on the globe as its strategy blends technology, culture and dedication to a workable plan.",
      },
      {
        type: "p",
        content:
          "AccelESG’s impact extends beyond the business sphere as it actively engages with stakeholders to develop beneficial transformations globally. The company works to address persistent environmental and social challenges, from climate change mitigation to social equity and inclusion, through partnerships with non-profit organizations, academic institutions and government agencies. AccelESG promotes collaborations and knowledge distribution to strengthen the impact and unified progress toward a greener and more equitable future.",
      },
    ],
  },
  {
    id: 9,
    title:
      "Bedrock Technology Inc. and AccelESG Inc. Forge Strategic Alliance to Revolutionize Global Supply Chain Sustainability",
    subtitle: "by admin | Mar 21, 2024 | Latest News | 0 comments",
    image: assets.mar21_2024,
    bannerImage: assets.bedrockbanner,
    description: [
      {
        type: "p",
        content:
          "ATLANTA, GA, March 06, 2024 /24-7PressRelease/ — Bedrock Technology Inc., an industry leader renowned for delivering world-class supplier management solutions, and AccelESG, a distinguished pioneer in sustainability technology, are delighted to announce a transformative and expansive partnership.",
      },
      {
        type: "p",
        content:
          "This landmark collaboration marks a significant milestone for both organizations as they combine their formidable strengths to lead a paradigm shift in sustainable practices within the dynamic procurement/supply chain sector and across diverse industries. Bedrock’s extensive expertise in the intricacies of the procurement and accounts payable industries seamlessly integrates with AccelESG’s proven track record in developing and implementing comprehensive and sustainable technology solutions.",
      },
      {
        type: "h3",
        content: "Key Pillars of the Partnership",
      },
      {
        type: "ul",
        content: [
          "Enhanced Sustainability Metrics: Bedrock’s automated supplier management portal will seamlessly incorporate AccelSUPPLY’s robust sustainability analytics, enriching procurement processes with enhanced sustainability metrics. This integration ensures a comprehensive view of environmental, social, and governance (ESG) factors throughout the procurement lifecycle.",
          "Ethical Sourcing Empowerment: Bedrock’s customers will benefit from AccelSUPPLY’s advanced features in ethical sourcing, providing real-time insights into supplier sustainability credentials. This integration empowers procurement professionals to make informed decisions that align with ethical and sustainable sourcing practices.",
          "Carbon Footprint Tracking: Bedrock’s digital onboarding and verification technology will now feature AccelSUPPLY’s carbon footprint tracking capabilities. This integration enables customers to monitor and manage the environmental impact of their procurement activities, contributing to a more sustainable and responsible supply chain.",
          "Comprehensive Stakeholder Engagement: Bedrock and AccelESG will collaborate to facilitate stakeholder engagement through their integrated solutions. This includes involving suppliers, clients, and industry partners in sustainable procurement initiatives, fostering a collective commitment to responsible business practices.",
        ],
      },
      {
        type: "h3",
        content: "Quotes from Leadership",
      },
      {
        type: "quote",
        content:
          '"As we embark on this transformative journey with AccelESG, we are driven by the belief that sustainability is not just a responsibility; it’s an opportunity for innovation and positive change. By partnering with AccelESG, we aim to expand upon our real-time risk and banking verification solutions to not only meet but exceed industry standards, setting a new benchmark for sustainable procurement." — Osama Sabbah, Founder and CEO of Bedrock',
      },
      {
        type: "quote",
        content:
          '"AccelESG is proud to collaborate with Bedrock, an organization at the forefront of delivering world-class procurement technology. Together, we will harness our collective expertise to create sustainable supply chain models that not only benefit Bedrock’s customers but contribute to a more sustainable and resilient global economy." — Raj Khaware, Founder and Chief Strategy Officer of AccelESG',
      },
      {
        type: "p",
        content:
          "This transformative partnership represents a shared commitment to driving positive change across the procurement and supply chain landscape. Bedrock and AccelESG are poised to inspire others and contribute significantly to a more sustainable and responsible future.",
      },
      {
        type: "h3",
        content: "About Bedrock",
      },
      {
        type: "p",
        content:
          "Bedrock is the world’s leading provider of supplier management technology and services. Bedrock recovers lost revenue, simplifies payments, minimizes risk, and reduces onboarding time for finance and procurement teams.",
      },
      {
        type: "p",
        content:
          "Bedrock leverages cutting edge API integration to all major ERP and P2P solutions and machine learning technology to replace human error with next-level efficiency, completely digitizing supplier onboarding and automating critical risk/banking verification checkpoints on a global scale.",
      },
      {
        type: "p",
        content:
          "Bedrock’s user-friendly workflows and dashboard reporting give unparalleled real-time process transparency and control. Combining elegance and simplicity with functionality, Bedrock is your foundational supplier management solution.",
      },
      {
        type: "h3",
        content: "About AccelESG",
      },
      {
        type: "p",
        content:
          "Welcome to AccelESG, a trailblazer in sustainability technology. We are a team of innovators committed to harnessing the power of technology to address sustainability challenges and pave the way for a greener, more sustainable world.",
      },
      {
        type: "p",
        content:
          "At AccelESG, our mission is to be at the forefront of driving positive change through technology. We are committed to helping businesses embrace and implement ESG principles, build sustainable supply chains, fostering sustainability, social responsibility, and sound governance in every aspect of their operations.",
      },
      {
        type: "p",
        content:
          'Whether you’re a business seeking to strengthen your ESG practices or an investor looking for tech-driven ESG insights and "plan to action", we invite you to join us on the journey toward a more sustainable and socially responsible future.',
      },
    ],
  },
  {
    id: 10,
    title: "Pioneering ESG Reporting: A New Era Unveiled with AccelTRACK",
    subtitle: "by accelesg | Feb 9, 2024 | Latest News | 0 comments",
    image: assets.ESGReporting,
    bannerImage: assets.pionerringbanner,
    description: [
      {
        type: "p",
        content:
          "ATLANTA, GA, February 05, 2024 /24-7PressRelease/ — In a rapidly evolving business landscape, where sustainability and corporate responsibility take center stage, I am thrilled to announce a significant milestone in our journey towards innovation and sustainability. Today, we officially launch our pioneering ESG Reporting Product, a groundbreaking solution that empowers businesses to navigate the complex landscape of Environmental, Social, and Governance (ESG) considerations with precision, impact, and accountability.",
      },
      {
        type: "p",
        content:
          "In an era where corporate responsibility and transparency are immutable, AccelESG takes pride in spearheading positive change through technology. As Chief Product Officer, I am excited to introduce our latest achievement – the first product in our Accel Plus Marketplace that exceeds the growing demand for robust ESG reporting tools.",
      },
      {
        type: "p",
        content:
          "Ah… ESG… From carbon emissions to ethical supply chains, from corporate governance to your social and environmental responsibility, ESG is the utopia of the world where everything works simply and efficiently, where all your data is available with the touch of a button in a single, simple, auditable, and secure platform.",
      },
      {
        type: "p",
        content:
          "You’re thinking “Yeah right!” and you are, in fact, correct! For most executives, hearing “ESG” conjures images of wading upstream… through a shark-infested treacle with the reward for your efforts being a drop of death down a waterfall onto jagged pile rocks.",
      },
      {
        type: "p",
        content:
          "The ESG river has become increasingly muddied by regulatory requirements, high-priced consultants peddling the ‘latest and greatest’ gimmick, and, software solutions that were developed for other business streams that have been hammered and beaten to repurpose them to resemble some kind of reporting and strategy tool but with such limited understanding of the ESG landscape that the ‘gold’ standard of reportable data is often worth less than sharks swimming next to you in the treacle.",
      },
      {
        type: "p",
        content:
          "Such complex systems won’t last – the excessive fees and complexity will soon become a nightmare to maintain as your organization grows, shifts, and expands, bringing you closer and closer to the waterfall with your only chance being to cling onto the raft that has been built for another purpose… Without massive continual spend, it won’t last.",
      },
      {
        type: "p",
        content:
          "So let me ask you this. Isn’t it time to make ESG sustainable?",
      },
      {
        type: "p",
        content:
          "And you’re thinking “What does that even mean?”. What if I told you that implementing ESG correctly would directly affect your bottom line, keep you compliant with the ever-evolving regulatory requirements, and save the environment all in one? Fair enough – that’s the dream, but where do we start?",
      },
      {
        type: "p",
        content:
          "Well, how about we start at the beginning? Your organization already has most of the information you require sitting in various databases and data sources scattered around your company. We need to bring that together, clean it, check that it’s accurate, prepare it for audit, transform it into reports for carbon emissions, governance, social or regulatory compliance, and then present it to the world.",
      },
      {
        type: "p",
        content:
          "If you’ve been investigating or journeying with this for a while now, you’re probably thinking 3, 4, 5 very expensive systems, right? And probably more if you go with what the consultants will tell you is needed to ‘seamlessly integrate’ your systems. This is where most companies make their first mistake. They buy the lie that your implementation has to be complex because sustainability is complex.",
      },
      {
        type: "p",
        content:
          "Introducing AccelPLUS, AccelESG’s new digital marketplace and home to AccelTRACK – Simple, Powerful, and Auditable. It looks pretty good too.",
      },
      {
        type: "p",
        content:
          "With AccelTRACK, you get a single, streamlined platform where data from varied sources converge, providing seamless integration and ensuring your ESG reporting is as comprehensive as it is coherent. No more multiple systems swimming in the waters next to you vying for funding and resources.",
      },
      {
        type: "p",
        content:
          "AccelTRACK aligns with top-tier reporting frameworks like GRI, SASB, and TCFD, giving you innate adherence to global standards. With AccelTRACK, your reports are more than just numbers; they’re a testament to your global commitment to sustainability.",
      },
      {
        type: "p",
        content:
          "In the realm of ESG, trust is everything. AccelTRACK is designed to rigorously check data accuracy, highlight potential errors, and help ensure that all your data is 100% audit-ready 100% of the time – the elusive GOLD standard of data reporting.",
      },
      {
        type: "p",
        content:
          "By design, AccelTRACK facilitates accurate, accessible, auditable, and transparent reporting, fostering communication with investors, customers, and employees, and assisting you in your governance journey into stakeholder engagement.",
      },
      {
        type: "p",
        content:
          "We also understand that your journey is not the same as any other company, so we designed AcceTRACK to be easily customized for reporting against any data in our system. AccelTRACK is not simply repurposed software that we are using for ESG. It was designed exclusively for ESG.",
      },
      {
        type: "p",
        content:
          "No, Accel Track won’t cook you dinner or clean your car, but it will help you clean out the shark-infested treacle-river.",
      },
      {
        type: "p",
        content: "Ready to go for a swim?",
      },
      {
        type: "p",
        content:
          "AccelESG invites businesses to lead the charge in reshaping the narrative around ESG reporting, making a lasting impact on our communities and the planet.",
      },
      {
        type: "h3",
        content: "Thank You",
      },
      {
        type: "p",
        content:
          "Mark Becking, Chief Product and Sustainability Officer, AccelESG Inc.",
      },
      {
        type: "h3",
        content: "About AccelESG Inc.",
      },
      {
        type: "p",
        content:
          "Welcome to AccelESG, a trailblazer in sustainability technology. We are a team of innovators committed to harnessing the power of technology to address sustainability challenges and pave the way for a greener, more sustainable world.",
      },
      {
        type: "p",
        content:
          "At AccelESG, our mission is to be at the forefront of driving positive change through technology. We are committed to helping businesses embrace and implement ESG principles, build sustainable supply chains, fostering sustainability, social responsibility, and sound governance in every aspect of their operations.",
      },
      {
        type: "p",
        content:
          "Whether you’re a business seeking to strengthen your ESG practices or an investor looking for tech-driven ESG insights and “plan to action”, we invite you to join us on the journey toward a more sustainable and socially responsible future.",
      },
    ],
  },
];

const LatestNewsDetails = () => {
  const { id } = useParams();
  const blog = latestnewsdetails.find((blog) => blog.id === parseInt(id));

  if (!blog) {
    return <div>Blog not found</div>;
    <img src={assets.careerbanner} alt="" data-aos="fade-in" />;
  }

  return (
    <>
      <div className="innerbanner-section-1">
        <div className="relative-2">
          <div className="s2-heading-text">
            <h1 data-aos="zoom-in">
              Stay updated with the pulse of climate-tech innovation.
            </h1>
            <p data-aos="zoom-in">
              Catch the latest breakthroughs, partnerships, deployments, and
              leadership moves as Accel1 accelerates sustainable impact across
              regions — from Rajasthan’s farms to global boardrooms.
            </p>
          </div>
          <img src={assets.careerbanner} alt="" data-aos="fade-in" />
        </div>
      </div>
      <div className="blog-inner">
        <div className="wrapper ">
          {/* Banner Image */}
          <div className="banner">
            <h1>{blog.title}</h1>
            <p>{blog.subtitle}</p>
            <img
              src={blog.bannerImage}
              alt={`${blog.title} Banner`}
              className="banner-image"
            />
          </div>

          {/* Blog Content */}
          <div className="content">
            <div>
              {blog.description.map((item, index) => {
                if (item.type === "p") {
                  return <p key={index}>{item.content}</p>;
                } else if (item.type === "h2") {
                  return <h2 key={index}>{item.content}</h2>;
                } else if (item.type === "h3") {
                  return <h3 key={index}>{item.content}</h3>;
                } else if (item.type === "ul") {
                  return (
                    <ul key={index}>
                      {item.content.map((listItem, idx) => (
                        <li key={idx}>
                          {typeof listItem === "object" ? (
                            listItem.bold ? (
                              <strong>{listItem.text}</strong>
                            ) : (
                              listItem.text
                            )
                          ) : (
                            listItem
                          )}
                        </li>
                      ))}
                    </ul>
                  );
                } else if (item.type === "quote") {
                  return (
                    <blockquote
                      key={index}
                      style={{ fontStyle: "italic", margin: "20px 0" }}
                    >
                      {item.content}
                    </blockquote>
                  );
                } else if (item.type === "image") {
                  return (
                    <div
                      key={index}
                      style={{ textAlign: "center", margin: "20px 0" }}
                    >
                      <img
                        src={item.src}
                        alt={item.title}
                        style={{ maxWidth: "100%" }}
                      />
                      <p style={{ fontStyle: "italic" }}>{item.title}</p>
                    </div>
                  );
                }
                return null;
              })}
            </div>

            <BlogsForm />

            <Link to="/" className="backtoblog">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
              >
                <path
                  d="M20.2376 13.0719L7.98975 13.2992L13.3363 18.4509L12.6903 19.213L6.0708 12.8347L12.4491 6.21525L13.1229 6.95288L7.9712 12.2994L20.2191 12.0721L20.2376 13.0719Z"
                  fill="#B09955"
                />
              </svg>
              Back to Blog Page
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default LatestNewsDetails;
